"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_currency_input_field_1 = __importDefault(require("react-currency-input-field"));
const JkcNumber = (props) => {
    const { name, settings, onChangeEvent, onBlurEvent, onFocusEvent, onKeyUpEvent, onKeyDownEvent, } = props;
    const onFocus = (event) => {
        event.target.selectionStart = event.target.selectionEnd =
            event.target.value.length;
        onFocusEvent && onFocusEvent(event);
    };
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 7px 0px 7px" : "10px 5px 0px 5px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        textAlign: "right",
    };
    let fieldStyle = {
        position: "relative",
        width: "100%",
        display: settings.fieldTypes == "Grid" ? "flex" : "block",
        borderTop: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        borderBottom: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        marginTop: "-1px",
    };
    if (settings.fieldTypes == "Grid") {
        fieldStyle.alignItems = "center";
    }
    let fieldLablStyle = {
        width: settings.fieldTypes == "Grid" ? "30%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
    };
    let fieldInputStyle = {
        width: settings.fieldTypes == "Grid" ? "70%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
        borderLeft: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        position: "relative",
    };
    if (settings.fieldTypes == "Grid") {
        fieldLablStyle.textAlign = "right";
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)(react_currency_input_field_1.default, { id: settings.id ? settings.id : name, name: name, tabIndex: settings.tabIndex ? settings.tabIndex : undefined, disabled: settings.disabled ? settings.disabled : false, readOnly: settings.readOnly ? settings.readOnly : false, placeholder: settings.placeholder ? settings.placeholder : "", value: (settings === null || settings === void 0 ? void 0 : settings.value) ? settings.value : undefined, className: settings === null || settings === void 0 ? void 0 : settings.className, onValueChange: onChangeEvent, style: Object.assign(Object.assign(Object.assign({}, inputStyle), settings.inputStyle), { paddingRight: 15 }), allowDecimals: settings.allowDecimals ? settings.allowDecimals : undefined, allowNegativeValue: settings.allowNegativeValue
                        ? settings.allowNegativeValue
                        : undefined, decimalsLimit: settings.decimalsLimit ? settings.decimalsLimit : undefined, decimalScale: settings.decimalScale ? settings.decimalScale : undefined, fixedDecimalLength: settings.fixedDecimalLength
                        ? settings.fixedDecimalLength
                        : undefined, prefix: settings.prefix ? settings.prefix : undefined, suffix: settings.suffix ? settings.suffix : undefined, decimalSeparator: settings.decimalSeparator ? settings.decimalSeparator : undefined, groupSeparator: settings.groupSeparator ? settings.groupSeparator : undefined, 
                    // intlConfig = {settings.intlConfig ? settings.intlConfig : {}}
                    disableAbbreviations: settings.disableAbbreviations
                        ? settings.disableAbbreviations
                        : undefined, disableGroupSeparators: settings.disableGroupSeparators
                        ? settings.disableGroupSeparators
                        : undefined, maxLength: settings.maxLength ? settings.maxLength : undefined, step: settings.step ? settings.step : undefined, onBlur: onBlurEvent, onFocus: onFocus, onKeyUp: onKeyUpEvent, onKeyDown: onKeyDownEvent }) }))] })));
};
exports.default = JkcNumber;
